import { connect } from 'react-redux';
import { saveGlobalConfig, updateDates } from '../../FilterActions';
import { setSuccessMessage } from '../../../../modules/App/ErrorsActions';
import { getSwitchConnectionMessage, prepareUrl } from '../../../../util/integrations';
import { DateRangePicker } from './DateRangePicker';

const mapDispatchToProps = dispatch => {
  return {
    setSuccessMessage: (msg, props) => dispatch(setSuccessMessage(msg, props)),
    saveConfig: updateHash => dispatch(saveGlobalConfig(true, updateHash)),
    updateValue: (val, update) => dispatch(updateDates(val, update))
  };
};

const mapStateToProps = state => {
  return {
    app: state.app.app,
    user: state.auth.user,
    selected: state.dashboards.selected,
    value: state.filters.dates,
    dateFormat: state.filters.dateFormat,
    dashboard: state.dashboards.selected
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { app, user, selected } = stateProps;

  const msg = getSwitchConnectionMessage(selected, app, user);
  const switchConnection = msg === true ?
    () => window.location.replace(prepareUrl(selected.application, 'api/tenant/integration/switch', { accountId: selected.accountId, from: window.location.pathname })) :
    msg ?
      () => dispatchProps.setSuccessMessage(msg, { toastId: 'switch_connection' }) :
      undefined

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    switchConnection
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps, mergeProps)(DateRangePicker);
export { connected as DatePicker };
